import { useEffect, useRef, useState } from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { fDateTimeWithTimezone } from "../../../../../utils/formatTime";

OrderItemDeletion.propTypes = {
  logItem: PropTypes.object,
  setHighlightedRow: PropTypes.func,
}

const titleStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'block',
  wordBreak: 'normal',
  cursor: 'pointer',
};

export default function OrderItemDeletion({ logItem, setHighlightedRow }) {

  const descRef = useRef(null);
  const [isDescOverflowing, setIsDescOverflowing] = useState(false);

  useEffect(() => {
    const descEl = descRef.current;
    if (descEl) setIsDescOverflowing(descEl.scrollWidth > descEl.clientWidth);
  }, []);

  return <Box>
    <Box onClick={() => setHighlightedRow(logItem.id)}>
      <Tooltip title={logItem.itemDescription || ''} disableHoverListener={!isDescOverflowing} placement="top">
        <Typography ref={descRef} variant="body" sx={{...titleStyle, textDecoration: 'underline'}} color="info.main">
          {logItem.itemDescription}
        </Typography>
      </Tooltip>
    </Box>
    <Typography variant="body" color="info.main">
      was deleted from the order {logItem.deletedBy ? `by ${logItem.deletedBy}` : ''}
    </Typography>
    <Typography variant="body2" color="black">
      {fDateTimeWithTimezone(logItem.dateAdded)}
    </Typography>
  </Box>
}
